import _toConsumableArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { useCallback } from 'react';
export var denormalizeValue = function denormalizeValue(value, multiple) {
  return multiple ? value : value[0];
};
export var useOnValueUpdate = function useOnValueUpdate(setInternalValue, onSelect, onChange, name) {
  return useCallback(function (internalValue, multiple, selectedOption, itemIndex, options, isFlat) {
    var chosenItem = selectedOption.value;

    if (typeof chosenItem === 'undefined') {
      return;
    }

    var nextValue;

    if (multiple) {
      if (internalValue.includes(chosenItem)) {
        nextValue = internalValue.filter(function (item) {
          return item !== chosenItem;
        });
      } else {
        nextValue = [].concat(_toConsumableArray(internalValue), [chosenItem]);
      }
    } else {
      nextValue = [chosenItem];
    }

    if (onChange) {
      onChange({
        target: {
          value: denormalizeValue(nextValue, multiple),
          name: name
        }
      });
    }

    if (onSelect && !multiple && options) {
      var option = isFlat ? selectedOption.label : selectedOption;

      if (typeof option === 'number') {
        option = option.toString();
      }

      onSelect(option, options.indexOf(option));
    }

    setInternalValue(nextValue);
  }, [onSelect, onChange, setInternalValue, name]);
};